// import { addYears } from 'date-fns';
import { RuleProps } from 'types/application';
import { SECT_ORGANISATION } from '../licenceOrganisation';

export const SECT_TYPE = 'applicant-type-section';
export const SECT_FILER = 'filer-details';
export const SECT_APPLICANT = 'applicant-details';

export const AEL_GENERAL_FIELDS = [
    {
        sectionID: SECT_TYPE,
        sectionName: '',
        fieldList: [
            {
                id: 'applicant-type',
                label: 'I am applying:',
                type: 'radio',
                row: true,
                span: 12,
                options: [
                    {
                        optID: 'Applicant',
                        optLabel: 'As an Applicant'
                    },
                    {
                        optID: 'Filer',
                        optLabel: 'On behalf of an Applicant'
                    }
                ],
            }
        ]
    },
    {
        sectionID: SECT_FILER,
        sectionName: 'Filer Details',
        fieldList: [
            {
                id: 'id-type',
                label: 'ID Type',
                type: 'text'
            },
            {
                id: 'idno',
                label: 'ID No.',
                type: 'text'
            },
            {
                id: 'salutaion',
                apiID: 'Salutation',
                label: 'Salutation',
                type: 'text'
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'nationality',
                label: 'Nationality',
                type: 'text'
            },
            {
                id: 'mobile-no',
                label: 'Mobile No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'email',
                rule: { required: true, charLength: 320 }
            }
        ],
        rule: {
            baseIds: [`${SECT_TYPE}-applicant-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${SECT_TYPE}-applicant-type`] === 'Applicant');
                return result;
            }
        }
    },
    {
        sectionID: SECT_APPLICANT,
        sectionName: 'Applicant Details',
        fieldList: [
            {
                id: 'id-type',
                apiID: 'IDType',
                label: 'ID Type',
                type: 'text'
            },
            {
                id: 'idno',
                label: 'ID No.',
                type: 'text'
            },
            {
                id: 'salutaion',
                apiID: 'Salutation',
                label: 'Salutation',
                type: 'text'
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'nationality',
                apiID: 'Nationality',
                label: 'Nationality',
                type: 'text'
            },
            {
                id: 'mobile-no',
                label: 'Mobile No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'email'
            },
            {
                id: 'update-via-sms',
                label: 'Update via SMS?',
                type: 'text'
            },
            {
                id: 'address-type',
                label: 'Address Type',
                apiID: 'AddressType',
                type: 'dropdown',
                options: [{ optID: 'SG', optLabel: 'Singapore' }],
                defaultValue: 'SG'
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal',
                label: 'Postal Code',
                type: 'postal'
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'dropdown'
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                placeholder: 'Eg: 01, B1, 01M',
                span: 2
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                placeholder: 'Eg: #05-01, use 01',
                span: 2
            }
        ]
    },
    {
        sectionID: SECT_ORGANISATION,
        sectionName: 'Company Details',
        fieldList: [
            {
                id: 'companyName',
                label: 'Name of Company',
                type: 'text'
            },
            {
                id: 'officeNo',
                label: 'Office No.',
                type: 'text'
            },
            {
                id: 'uenNo',
                label: 'UEN No.',
                type: 'text'
            }
        ]
    }
];
